import { AuthenticatedUser } from '@/types/auth-base.types';

export function hasPersonalDataPendencies(user?: AuthenticatedUser): boolean {
  return !(user?.birthday && user?.gender && user?.legalName && user?.contact?.email);
}
